export const Background5Star = "./background-5star.jpg";
export const BackgroundBlackCar = "./background-black-car.jpg";
export const BackgroundDefault = "./background-default.jpg";
export const BackgroundDog = "./background-dog.jpg";
export const BackgroundHeartHands = "./background-heart-hands.jpg";
export const BackgroundSmoke = "./background-smoke.jpg";
